var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// TODO: pri prvnim pozadavku na zmenu udelat administraci
var operators = [
    'https://cdn.shopify.com/s/files/1/0575/8173/1991/files/favicon-228x228_180x180.png?v=1632748989',
    'https://img.okay.cz/img/frontenddev/chat_app/muz1.jpg',
    'https://img.okay.cz/img/frontenddev/chat_app/muz3.jpg',
    'https://img.okay.cz/img/frontenddev/chat_app/muz2.jpg',
    'https://img.okay.cz/img/frontenddev/chat_app/zena2.jpg',
    'https://img.okay.cz/img/frontenddev/chat_app/zena3.jpg',
];
export var Operators = React.memo(function () {
    return (_jsx("div", __assign({ className: "operators" }, { children: operators.map(function (operator, index) { return (_jsx("div", __assign({ className: "operator".concat(index, " ").concat(index === 0 ? 'active' : ''), style: { backgroundImage: "url(\"".concat(operator, "\")") } }, { children: _jsx("span", {}) }), index)); }) })));
});
